import React, { useEffect, useState } from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import { Header, Link } from "@amzn/awsui-components-react";
import { MAX_FILE_SIZE_IN_MB } from "../util";
import { FileUploadComponent } from "shared/programs/migration-acceleration-program/2024/fund-request/components/attachments/FileUploadComponent";
import {
  equals,
  getArtifacts,
} from "shared/programs/migration-acceleration-program/2024/fund-request/components/attachments/util";
import { IArtifactFileModel } from "shared/programs/migration-acceleration-program/2024/fund-request/components/attachments/types/fileTypes";
import { IGenericObject } from "shared/programs/migration-acceleration-program/2024/fund-request/types/CommonTypes";
import { useTranslation } from "react-i18next";
import { MIGRATION_ASSESSMENT_REPORT_TEMPLATE_LINK } from "shared/util/constants/constantValues";

const VmwareAssessmentReport = ({ data }: { data: IGenericObject }) => {
  const [files, setFiles] = useState<File[]>([]);
  const [fileIdToAttributes, setFileIdToAttributes] =
    useState<IArtifactFileModel>({});
  const { t } = useTranslation();

  useEffect(() => {
    const documents = data && data["documents"];
    if (!documents) return;
    const artifacts = getArtifacts({
      documents,
      filter: (actualType) => equals(actualType, "Migration Assessment Report"),
    });
    setFiles(artifacts.files || []);
    setFileIdToAttributes(artifacts.fileIdToAttributes);
  }, [data]);

  return (
    <Container
      header={
        <Header variant="h2">
          {t(
            "wizard.section.supportingDocumentation.content.vmwareAssessmentReport.header.title"
          )}
        </Header>
      }
    >
      <FileUploadComponent
        artifacts={{ files, fileIdToAttributes }}
        updateFiles={setFiles}
        setFileIdToAttributes={setFileIdToAttributes}
        label={t(
          "wizard.section.supportingDocumentation.content.vmwareAssessmentReport.fields.upload.label"
        )}
        supportingDocumentType="Migration Assessment Report"
        description={
          <>
            Select the link to download a new{" "}
            <Link
              external
              variant="primary"
              fontSize="inherit"
              href={MIGRATION_ASSESSMENT_REPORT_TEMPLATE_LINK}
            >
              migration assessment report template
            </Link>
            .
          </>
        }
        constraintText={`File size limit: ${MAX_FILE_SIZE_IN_MB} MB`}
      />
    </Container>
  );
};

export default VmwareAssessmentReport;
